export const companyProfile = {
  'companyProfile.searchCandidates': 'Search candidates',
  'companyProfile.goToDashboard': 'Go to Dashboard',
  'companyProfile.messageCenter': 'Message center',
}
